import { Stack } from '@mui/material';
import React from 'react';
import useBootstrapSize from '../../../hooks/useBootstrapSize';

export default function FlexContainer({ flexDirection, children, alignItems, ...props }) {
  const { isMobile } = useBootstrapSize();
  const myDirection = isMobile ? 'column' : 'row';
  const newAlignItems = alignItems === 'auto' ? (isMobile ? 'start' : 'center') : alignItems;
  return (
    <Stack
      display={'flex'}
      alignItems={newAlignItems}
      flexDirection={flexDirection || myDirection}
      {...props}>
      {children}
    </Stack>
  );
}
